import React from 'react';
import {aWeekMillisecond} from "../../../../util/varibles/constants";
import styles from './style.module.scss';
import {connect} from "react-redux";
import {IVesselHeight} from "../Vessels";
import {AppState} from "../../../../util/store/store";

const mapStateToProps = (state: AppState) => {
    return {
        first: state.overview.weeks[0].time,
        space: state.overview.weeks.length * aWeekMillisecond,
    }
};

interface IProps {
    source: any[]
    vesselHeight: IVesselHeight
    first: number
    space: number
}

const AvailableTimes: React.FC<IProps> = ({source, vesselHeight, first, space}) => {
    return <>
        {source.map((data: any) => {
            const {start_time, finish_time, isPermission, vesselId} = data;

            let style;

            if (vesselHeight[vesselId]) {
                style = {
                    height: `calc(var(--${vesselId}-height) + var(--more-height, 0px))`,
                    top: `var(--${vesselId}-top)`,
                    left: `calc(var(--calendar-content-width) * ${(start_time - first)} / ${space} + 160px)`,
                    width: `calc(var(--calendar-content-width) * ${(finish_time - start_time)} / ${space})`
                }
            } else {
                style = {
                    display: 'none'
                }
            }

            return <div
                key={data.id}
                className={styles.availableTime}
                style={style}
                data-is-permission={isPermission}
            />;
        })}
    </>;
};

export default connect(mapStateToProps, {})(AvailableTimes);
